module.exports = __webpack_public_path__ + "img/entertainment.03de972a.jpg";